import { useState } from "react";
import Header from "./components/Header";
import InputPanel from "./components/InputPanel";
import OutputPanel from "./components/OutputPanel";
import HowItWorks from "./components/HowItWorks";
import Footer from "./components/Footer";
import { rewriteBullets } from "./utils/api";
import "./styles/globals.css";

export default function App() {
  const [inputText, setInputText] = useState("");
  const [bullets, setBullets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [apiKey, setApiKey] = useState(localStorage.getItem("openai_key") || "");

  const handleGenerate = async () => {
    if (!inputText.trim()) return setError("Please paste your experience first.");
    if (!apiKey.trim()) return setError("Please enter your OpenAI API key.");
    setError("");
    setLoading(true);
    setBullets([]);
    try {
      const result = await rewriteBullets(inputText, apiKey);
      setBullets(result);
    } catch (err) {
      setError(err.message || "Something went wrong. Check your API key.");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveKey = (key) => {
    setApiKey(key);
    localStorage.setItem("openai_key", key);
  };

  return (
    <div className="app">
      <Header />
      <main className="main">
        <div className="hero">
          <h1 className="hero-title">
            Turn Raw Experience into<br />
            <span className="hero-accent">Impact-Driven Bullets</span>
          </h1>
          <p className="hero-sub">
            Paste your job description or experience. Get quantified, ATS-optimized resume bullets in seconds.
          </p>
        </div>

        <div className="panels">
          <InputPanel
            inputText={inputText}
            setInputText={setInputText}
            apiKey={apiKey}
            onSaveKey={handleSaveKey}
            onGenerate={handleGenerate}
            loading={loading}
            error={error}
          />
          <OutputPanel bullets={bullets} loading={loading} />
        </div>

        <HowItWorks />
      </main>
      <Footer />
    </div>
  );
}
